module.exports = __webpack_public_path__ + "img/block-quote.aef9658c.svg";